import { useState } from "react";
import { FaTrash } from "react-icons/fa";

const DeleteButtonWithConfirmation = ({ itemId, onDelete, onCancelDelete }) => {
  const [isConfirmingDelete, setIsConfirmingDelete] = useState(false);

  const handleDeleteClick = () => {
    setIsConfirmingDelete(true);
  };

  const handleCancelDelete = () => {
    setIsConfirmingDelete(false);
    onCancelDelete?.();
  };

  const handleDelete = () => {
    onDelete(itemId); // Calls the onDelete function passed as prop
    setIsConfirmingDelete(false); // Hide confirmation after deletion
  };

  return (
    <div className="flex items-center">
      {/* If confirming delete, show confirmation buttons */}
      {isConfirmingDelete ? (
        <div className="flex items-center">
          <span className="mr-2">Are you sure?</span>
          <button
            onClick={handleCancelDelete}
            className="ml-2 bg-gray-700 text-white px-2 py-1 rounded-md text-xs hover:bg-gray-600"
          >
            No
          </button>
          <button
            onClick={handleDelete}
            className="ml-2 bg-red-600 text-white px-2 py-1 rounded-md text-xs hover:bg-red-500"
          >
            Yes
          </button>
        </div>
      ) : (
        // If not confirming delete, show regular delete button
        <button
          onClick={handleDeleteClick}
          className="bg-gray-500 text-white px-3 py-2 rounded-md text-sm font-semibold hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-300 flex items-center"
        >
          <FaTrash className="h-5 w-5 mr-2" />
          Delete
        </button>
      )}
    </div>
  );
};

export default DeleteButtonWithConfirmation;
